import SpriteSymbol from "../../../../../../../node_modules/normacs_web/node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../../../../../node_modules/normacs_web/node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "cross",
  "use": "cross-usage",
  "viewBox": "0 0 64 64",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 64 64\" id=\"cross\">\n  <g fill=\"currentColor\">\n    <rect width=\"59.561\" height=\"6\" x=\"2.399\" y=\"29.179\" rx=\"3\" transform=\"rotate(135 32.18 32.18)\" />\n    <rect width=\"59.561\" height=\"6\" x=\"2.399\" y=\"29.179\" rx=\"3\" transform=\"rotate(45 32.18 32.18)\" />\n  </g>\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol